module.exports = __webpack_public_path__ + "static/media/justice.cdeb5e3f.jpg";